import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomeLanding from "./components/homepage/home_landing";
import LogoLoader from "./components/LogoLoader";
import VaranasiLanding from "./components/varanasi/varanasi_landing";
import TutorLanding from "./components/homepage/tutor";
import StudentLanding from "./components/homepage/student";
// eslint-disable-next-line no-unused-vars
import { Analytics } from "@vercel/analytics/react"

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <BrowserRouter>
      {isLoading ? (
        <LogoLoader />
      ) : (
        <Routes>
          <Route path="/" element={<HomeLanding />} />
          <Route path="/student" element={<StudentLanding />} />
          <Route path="/tutor" element={<TutorLanding />} />
          <Route path="/varanasi" element={<VaranasiLanding />} />
        </Routes>
      )}
    </BrowserRouter>
  );
}

export default App;